import {Button, ThemeProvider} from "@mui/material"
import {Input, message, Modal} from "antd"
import {post_response} from "helper/request"
import React, {Component} from 'react';
import {updateOrganisations} from "../../redux_actions/users.action";
import {connect} from "react-redux";
import { isSuperuser } from "utils/utils";
import {defaultTheme} from "../gammaviewer/themes";


class AddOrganisationModal extends Component {
    constructor(props) {
        super(props)

        this.state = {
            loading: false,
            active: false,
            name: "",
            error_msg: ""
        }
        this.is_superuser = isSuperuser();
    }

    closeModal = () => {
        this.setState({active: false, loading: false, name: "", error_msg: ""})
    }

    createOrganisation = () => {
        if (!this.state.name) return

        this.setState({loading: true})

        post_response('/api/organisation/', {name: this.state.name})
            .then((response) => {
                this.props.dispatch(updateOrganisations(response.data))
                message.success(`Successfully created organisation "${this.state.name}"`)
                this.closeModal()
            })
            .catch(err => {
                if(err?.response?.status === 400 && err?.response?.data?.name){
                    this.setState({error_msg: err?.response?.data?.name[0]})
                } else {
                    this.setState({error_msg: "Couldn't create organisation"})
                }
            })
            .finally(() => {
                this.setState({loading: false})
            })
    }

    render() {

        if (!this.is_superuser) return null;

        return (
            <React.Fragment>
                <ThemeProvider theme={defaultTheme}>
                    <Button
                        color="primary"
                        variant="outlined"
                        size="small"
                        onClick={() => this.setState({active: true})}
                    >
                        Add New Organisation
                    </Button>
                    <Modal
                        title="Create New Organisation"
                        visible={this.state.active}
                        onCancel={this.closeModal}
                        onOk={this.createOrganisation}
                        confirmLoading={this.state.loading}
                        okText="Create Organisation"
                        okButtonProps={{disabled: !(this.state.name)}}
                    >
                        <Input
                            value={this.state.name}
                            onChange={(e) => this.setState({name: e.target.value})}
                            placeholder="Organisation Name"
                        />
                        <div style={{color: "red"}}>{this.state.error_msg}</div>
                    </Modal></ThemeProvider>
            </React.Fragment>
        )
    }
}

const mapStateToProps = state => {
    return {};
};

export default connect(mapStateToProps)(AddOrganisationModal);